import { gql } from '@/utilities/gql';
import { NARRATIVE_OWNER_FRAGMENT } from '../NarrativeAuthor';
import { NARRATIVE_URL_COMPANY_FRAGMENT } from '@/pages/Narrative/utils/getNarrativeUrl';
import { NARRATIVE_CARD_ACTIONS_FRAGMENT } from './components/NarrativeCardActions';

export const NARRATIVE_CARD_FRAGMENT = gql(
  `
  fragment NarrativeCardFields on Narrative @_unmask {
    id
    slug
    updatedAt
    lastFeaturedAt
    primaryCount
    title
    isPublic
    commentKey
    excerpt
    type
    isSponsored
    company {
      id
      tickerSymbol
      name
      data {
        currencyInfo
      }
      analysisValue {
        priceTargetAnalystCount
      }
      info {
        url
        hasLogo
      }
      ...NarrativeUrlCompanyFields
    }
    owner {
      ...NarrativeOwnerFields
    }
    valuation {
      fairValue
      intrinsicDiscount
      revenuePercentageChange
    }
    voteCount {
      upvotes
    }
    draftUpdate {
      title
      coreExcerpt
      valuation {
        fairValue
        revenuePercentageChange
        intrinsicDiscount
      }
      updatedAt
    }
    earliestPublishedUpdate {
      willLockAt
    }
    latestPublishedUpdate {
      willLockAt
      coreExcerpt
      title
    }
    ...NarrativeCardActionsFields
  }
`,
  [
    NARRATIVE_URL_COMPANY_FRAGMENT,
    NARRATIVE_OWNER_FRAGMENT,
    NARRATIVE_CARD_ACTIONS_FRAGMENT,
  ]
);
